import * as React from 'react';

import { cn } from '@/lib/utils';
import { fieldDisabled, fieldFocus, fieldInvalid, fieldSurface } from './field-surface';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
	return (
		<textarea
			data-slot="textarea"
			className={cn(
				fieldSurface,
				fieldFocus,
				fieldDisabled,
				fieldInvalid,
				/* Sizing is the one thing a textarea does not share with the 32px controls. */
				'flex field-sizing-content min-h-16 w-full px-2.5 py-2 text-sm outline-none placeholder:text-muted-foreground',
				className
			)}
			{...props}
		/>
	);
}

export { Textarea };
